<template>
  <div class="boot-fail" role="alert">
    <div class="boot-fail__card">
      <div class="boot-fail__brand">OrderN</div>
      <h1 class="boot-fail__title">{{ TEXT.TITLE }}</h1>
      <p v-if="embed" class="boot-fail__text">{{ TEXT.EMBED_HINT }}</p>
      <template v-else>
        <p class="boot-fail__text">{{ TEXT.RELOAD_HINT }}</p>
        <button type="button" class="boot-fail__btn" @click="reload">{{ TEXT.RELOAD }}</button>
      </template>
    </div>
  </div>
</template>

<script>
/**
 * **부트 실패의 정적 복구 화면** (12R P9 · 원장 `EMBED-FIRST-NAV-FAIL-NO-SCREEN`).
 *
 * 최초 내비게이션이 끝내 실패하면(`utils/bootRecovery.bootFailureAction` → `fallback`) `main.js` 가 라우터·스토어·
 * 지연 청크에 **기대지 않고** 이 컴포넌트를 `#app` 에 그린다. 앱을 그냥 붙이면 라우터가 START 라 `router-view` 가 비고,
 * `/v/pos/*` 는 셸 없는 `EmbedLayout` 이라 백지가 그대로다 — 매직링크 토큰은 이미 소비돼 되돌아갈 길이 없다.
 *
 * **문구가 컴포넌트 안의 한국어 상수인 이유**: 이 화면은 부트 단계라 **i18n 이전**이다 — 언어 사전은 서버
 * (`/admin/api/lan/data/{locale}`)에서 읽어 오는데 그 요청·라우터·플러그인이 아직 서지 않았거나 실패한 자리다.
 * `deliveryMenuNotes.js`(화면 문구 SSOT)에 두지 않는 것도 같은 이유다 — 그 모듈의 문구는 `$t` 를 지나는 화면 문구이고
 * 이것은 앱이 없는 자리의 문구다. 진입 번들에 eager 로 들어간다(`main.js` 가 정적 import).
 *
 * Win7 WebView2(Chromium 109) 대상이라 CSS 에 `oklch`·`color-mix`·`:has`·container query 를 쓰지 않는다. 터치 타깃 44px.
 */
const TEXT = Object.freeze({
  TITLE: '화면을 열지 못했습니다',
  EMBED_HINT: 'POS 에서 다시 열어 주세요.',
  RELOAD_HINT: '잠시 후 다시 시도해 주세요.',
  RELOAD: '새로고침',
})

export default {
  name: 'BootFailureView',
  props: {
    /** POS 임베드 경로(`/v/pos/*`)인가 — 그 창에는 새로고침으로 돌아갈 화면이 없다(토큰이 소비됐다) */
    embed: { type: Boolean, default: false },
  },
  data() {
    return { TEXT }
  },
  methods: {
    reload() {
      window.location.reload()
    },
  },
}
</script>

<style scoped>
.boot-fail {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 24px;
  background: #f5f6f7;
  color: #1a1f23;
  font-size: 14px;
}
.boot-fail__card {
  width: 520px;
  max-width: 100%;
  padding: 32px;
  border: 1px solid #dfe3e6;
  border-radius: 14px;
  background: #fff;
  text-align: center;
}
.boot-fail__brand {
  color: #e0472b;
  font-size: 18px;
  font-weight: 900;
  letter-spacing: -0.03em;
}
.boot-fail__title {
  margin: 8px 0 0;
  font-size: 20px;
}
.boot-fail__text {
  margin: 14px 0 0;
  color: #4a5158;
  font-size: 15px;
  line-height: 1.6;
}
.boot-fail__btn {
  min-width: 160px;
  min-height: 44px;
  margin-top: 18px;
  padding: 0 20px;
  border: 0;
  border-radius: 999px;
  background: #e0472b;
  color: #fff;
  font: inherit;
  font-size: 15px;
  font-weight: 800;
  cursor: pointer;
}
</style>
